/**
 * Push Notifications API
 * 
 * Handles push notification-related API calls including:
 * - VAPID key retrieval
 * - Subscription management
 */

import api from './client';

export const pushApi = {
  /**
   * Get VAPID public key
   * @returns {Promise<string>} VAPID public key
   */
  async getVapidPublicKey() {
    const response = await api.get('/api/get_vapid_public_key');
    return response.data.vapidPublicKey;
  },

  /**
   * Subscribe to push notifications
   * @param {Object} subscription - Push subscription data
   * @returns {Promise<Object>} Subscription confirmation
   */
  async subscribe(subscription) {
    const response = await api.post('/api/push/subscribe', subscription);
    return response.data;
  },

  /**
   * Unsubscribe from push notifications
   * @param {string} endpoint - Subscription endpoint
   * @returns {Promise<Object>} Unsubscription confirmation
   */
  async unsubscribe(endpoint) {
    const response = await api.post('/api/push/unsubscribe', { endpoint });
    return response.data;
  },
};

export default pushApi;
